<template>
  <el-row>
    <el-col :span="24">
      <h3>Errors</h3>
      <el-table :data="errors">
        <el-table-column label="Date" width="250">
          <template slot-scope="scope">
            <strong>{{scope.row.created_at | dateString}}</strong>
          </template>
        </el-table-column>
        <el-table-column prop="message" label="Message"/>
      </el-table>
    </el-col>
  </el-row>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'LogOnErrors',
    props: {
      errors: {
        type: Array,
        default: [],
      },
    },
    filters: {
      dateString: function(date) {
        return moment.utc(date).local().format('MMMM Do YYYY h:mm:ss a');
      },
    },
  };
</script>
